import React, {
  InputHTMLAttributes,
  useRef,
  useState,
  useCallback,
} from "react";
import { Container, Error, InputTitle } from "./style";
import { IconBaseProps } from "react-icons";
import { FiAlertCircle } from "react-icons/fi";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string | number;
  error?: string;
  title?: string;
  icon?: React.ComponentType<IconBaseProps>;
}

const Input: React.FC<InputProps> = ({
  value,
  error,
  title,
  icon: Icon,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  return (
    <>
      {title && <InputTitle>{title}</InputTitle>}
      <Container isErrored={!!error} isFocused={isFocused} isFilled={isFilled}>
        {Icon && <Icon size={20} />}
        <input
          value={value}
          ref={inputRef}
          type="text"
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          {...rest}
        />
        {error && (
          <Error title={error} type="error">
            <FiAlertCircle size={20} />
          </Error>
        )}
      </Container>
    </>
  );
};

export default Input;
